module.exports = __webpack_public_path__ + "r-v3/img/note_white.d1d4c3d5.svg";